import { t as __t } from "i18next";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callLogin } from "../../api/login/service";
import { setData } from "../../redux/loginSlice";
import { handleInput, handleInvalid, handleSetCookie, handleGetCookie } from "../../utils/commonUtil";
import "../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import Cookies from 'js-cookie';

const Index = () => {
	const { t } = useTranslation()
	const dispath = useDispatch();
	const [login, setLogin] = useState({ username: '', password: '', firebaseToken: 'erjagvjiSfG4Ol287BVC4D:APA91bF7JtiC-u5yJ2Pj5xZCIbrpmq5zqwLGyZUSZ0t5cb8PdqCk0A7Yq5TmezpiSHPFd5P9MU1QFjWNauIJQut_B5nJLaFRGMDFEQsg4eiKvEX-zHCgduY', systemName: 'web' })
	const [showPassword, setShowPassword] = useState(false);
	const toggleShowPassword = () => setShowPassword((v) => !v);
	useEffect(() => {
		initial()
	}, []);

	const initial = () => {

	}

	const submitLogin = async (event) => {
		event.preventDefault();

		const res = await dispath(callLogin(login));
		if (res.payload?.responseCode == "00000") {
			if (res?.payload?.user?.roleId === 4) {
				Swal.fire(__t("uiText.text308"), __t("uiText.text309"), "warning");
				return
			}
			setLogin({ username: '', password: '' })
			let data = {
				accessToken: res?.payload?.accessToken,
				user: res?.payload?.user,
				agent: res?.payload?.info,
				refreshToken: res?.payload?.refreshToken,
				expiresIn: res?.payload?.expiresIn
			}
			handleSetCookie('auth', data, 60)
			dispath(setData(data))

			localStorage.setItem('adminMenu', JSON.stringify(res?.payload?.adminMenu));
			window.location.href = "/admin/dashboard"
		}
	}

	const handleChange = (e) => {
		const { name, value } = e.target;
		setLogin({
			...login,
			[name]: value,
		});
	};

	return (
		<div className="lti-login-page d-flex justify-content-center align-items-center">
			<div className="lti-login-card bg-white shadow-lg my-login">
				<div className="d-flex justify-content-center">
					<img src="/images/lti_logo.png" className="" alt="logo" />
				</div>

				<form className="p-0" onSubmit={submitLogin}>
					<div className="form-group mt-3">
						<label>{t('login.username')}<span className="text-danger">*</span></label>
						<input
							type="text"
							name="username"
							className="form-control-uld"
							placeholder={t('login.username')}
							onInput={handleInput}
							onChange={handleChange}
							value={login.username}
							onInvalid={(event) => handleInvalid(event, t('login.username'))}
							required />
					</div>

					<div className="form-group mt-3">
						<label> {t('login.password')} <span className="text-danger">*</span> </label>
						<div className="position-relative" style={{ paddingLeft: 0, paddingRight: 0 }}>
							<input
								type={showPassword ? "text" : "password"}
								name="password"
								className="form-control-uld"
								placeholder={t('login.password')}
								onInput={handleInput}
								onChange={handleChange}
								value={login.password}
								onInvalid={(event) => handleInvalid(event, t('login.password'))}
								required
								// เผื่อพื้นที่ให้ไอคอนด้านขวา
								style={{ paddingRight: "3rem" }}
							/>

							<button
								type="button"
								className="btn btn-link p-0 m-0 position-absolute top-50 end-0 translate-middle-y me-2 text-muted"
								onClick={toggleShowPassword}
								aria-label={showPassword ? t('login.hidePassword') : t('login.showPassword')}
								title={showPassword ? t('login.hidePassword') : t('login.showPassword')}
							>
								{/* eye / eye-off (SVG แบบไม่ต้องพึ่งไลบรารี) */}
								{showPassword ? (
									// eye-slash
									<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
										<path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-5 0-9.27-3.11-11-8 1.02-2.84 2.98-5.11 5.47-6.46" />
										<path d="M1 1l22 22" />
										<path d="M9.88 9.88A3 3 0 0 0 12 15a3 3 0 0 0 2.12-.88" />
										<path d="M14.12 14.12L9.88 9.88" />
										<path d="M21.54 8.46A11.05 11.05 0 0 0 12 4c-1.07 0-2.1.15-3.07.43" />
									</svg>
								) : (
									// eye
									<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
										<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
										<circle cx="12" cy="12" r="3" />
									</svg>
								)}
							</button>
						</div>
					</div>

					<div className="form-group mt-4">
						<button type="submit" className="theme-btn btn-style-one w-100">
							{t('login.btnLogin')}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default Index;
